import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Text = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '155px')};
    font: ${({ font }) => (font ? font : '16px Avenir Next World')};
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;
    padding-top: 12px;
    line-height: ${({ lineHeight }) => lineHeight};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '0')};
    ${media.mobileDevice` 
        height: ${({ height }) => (height ? height : '190px')};
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};;
        font-family:'AvenirNextWorld Regular';
    `};
`;

export const SubText = styled(Text)`
    height: ${({ subTextHeight }) => (subTextHeight ? subTextHeight : '63px')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    ${media.mobileDevice` 
    height: ${({ subTextHeight }) => (subTextHeight ? subTextHeight : 'auto')};
    `};
`;

export const Div = styled.div`
    display: flex;
    justify-content: ${({ center, justifyContent }) =>
        justifyContent ? justifyContent : center ? 'center' : 'flex-end'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    position: ${({ position }) => (position ? position : 'sticky')};
    flex-direction: ${({ showCancel }) => (showCancel ? 'row' : '')};
    bottom: 0;
    ${media.mobileDevice` 
    
    `};
`;

export const DesktopWrap = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : ''};

    ${media.mobileDevice` 
        flex-wrap:wrap;
    `};
`;

export const DraftDiv = styled.div`
    width: 420px;
    //height: 115px;
    ${media.mobileDevice`
         width:${({ width }) => (width ? width : '310px')};             
         `}
`;

export const MyProfileDiv = styled.div`
    width: 430px;
    height: 450px;
    ${media.mobileDevice`
         width:310px;
         height:440px;                
         `}
`;

export const ProductDelayDiv = styled.div`
    width: 430px;
    height: 200px;
    ${media.mobileDevice`
         width:310px;
         height:240px;                  
         `}
`;

export const UnsavedChangesDiv = styled.div`
    width: 430px;
    display: flex;
    flex-direction: column;
    height: ${({ divHeight }) => (divHeight ? divHeight : '63px')};
    ${media.mobileDevice`
         width:310px;
         height:160px;                 
    `}
`;

export const Subtitle = styled.div`
    font-family: 'AvenirNextWorld Regular';
    color: '#202124';
    font-size: 16px;
    margin-bottom: 10px;
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-top: 10px;
`;

export const ExpeditedDiv = styled.div`
    width: 420px;
    height: 50px;
    ${media.mobileDevice`
         width:310px;
         height:50px;                  
         `}
`;
export const AddedMoreThanTenItemsDiv = styled(ExpeditedDiv)``;
export const NonTissueSetSurgeryDiv = styled(ExpeditedDiv)``;

export const ItemNotAvailableDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 420px;
    overflow-y: visible;
    height: ${({ height }) => (height ? height : '205px')};
    ${media.mobileDevice`
         width:310px;
         height: ${({ mbHeight }) => (mbHeight ? mbHeight : '210px')};
         min-height: 210px;
    `}
`;
export const ItemNotAllowedAsExtraDiv = styled(ItemNotAvailableDiv)``;

export const ShortText = styled(Text)`
    color: #130e4a;
    font-size: 17px;
    font-family: 'AvenirNextWorld Demi';
    padding-top: 0px;
    display: flex;
    justify-content: center;

    ${media.mobileDevice`
font-family:'AvenirNextWorld Demi';
display:flex;
justify-content:flex-start;           
         `}
`;
export const ExcludedItemsNotAddedDiv = styled.div`
    width: 420px;
    max-height: 550px;
    overflow-y: auto;
    ${media.mobileDevice`
         width:310px; 
         max-height:400px;
         overflow-y:auto;             
         `}
`;
export const ItemsText = styled.div`
    height: 30px;
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
    color: #130e4a;
    letter-spacing: -0.11px;
    opacity: 1;
    display: flex;
    justify-content: center;
    ${media.mobileDevice` 
    height: ${({ height }) => (height ? height : '30px')};
    justify-content:flex-start;
    font-size:14px;
`};
`;
export const ItemsNotAllowedText = styled.div`
    font-size: 16px;
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    letter-spacing: -0.11px;
    opacity: 1;
    display: flex;
    justify-content: flex-start;
    margin: ${({ margin }) => (margin ? margin : '15px 0 15px 0')};
    height: ${({ height }) => (height ? height : '35px')};
    ${media.mobileDevice` 
    font-size:14px;
    margin:${({ margin }) => (margin ? margin : '15px 0 0 0')};
`};
`;

export const ItemsSubText = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '55px')};
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;

    ${media.mobileDevice` 
    height:${({ height }) => (height ? height : '55px')};
    margin-bottom:15px;
`};
`;
export const ItemTitle = styled.div`
    flex-basis: 30%;
    color: #130e4a;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    flex-basis:40%;       
         `}
`;
export const Description = styled.div`
    flex-basis: ${({ flexBasis }) => (flexBasis ? flexBasis : '70%')};
    ${media.mobileDevice`
    flex-basis:60%;       
         `}
`;

export const ExclusionItemsNotAllowedDiv = styled.div`
    width: ${({ width }) => (width ? width : '700px')};
    max-height: 550px;
    overflow-y: visible;
    height: ${({ height }) => (height ? height : '205px')};
    ${media.mediumDevice`
    width: ${({ width }) => (width ? width : '650px')};
    max-height:500px;          
    `};
    ${media.mobileDevice`
         width:310px ;
         max-height:520px;
         overflow-y: ${({ hideScroll }) => (hideScroll ? 'hidden' : 'scroll')}; 
         height: ${({ mbHeight }) =>
             mbHeight ? mbHeight : '210px'};              
        `};
`;

export const ButtonFooter = styled.div`
    display: flex;
    flex-direction: ${({ showCancelButton }) =>
        showCancelButton ? 'row' : ''};
    justify-content: ${({ center, showCancelButton }) =>
        showCancelButton && center ? 'center' : 'flex-end'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    position: sticky;
    bottom: 0;
    ${media.mobileDevice` 
    
    `};
`;
export const NoInventoryShippingDiv = styled.div`
    width: 430px;
    height: 140px;
    ${media.mobileDevice`
         width:310px;
         height:139px;
                           
         `}
`;
export const ShippingText = styled(Text)`
    font: 15px Avenir Next World;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    width: 400px;
    height: 90px;
    line-height: 20px;
    ${media.mobileDevice`
    font:14px Avenir Next World;
    font-family:'AvenirNextWorld Regular';
    width:290px;  
         `}
`;

export const EmptyCart = styled.div`
    display: flex;
    flex-direction: column;
    width: 430px;
    height: ${({ height }) => (height ? height : '165px')};
    ${media.mobileDevice`
         width:310px;
                           
         `}
`;

export const WarningMessage = styled.p`
    font: 18px Avenir Next World;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    margin: 12px 0 0 0;
`;
export const AlertImageContainer = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

export const AlertImage = styled.img`
    width: 18%;
    ${media.mobileDevice`
        width: 25%;
    `};
`;
export const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
`;

export const ProductsContainer = styled.div`
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 2rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    overflow: scroll;
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : '142px')};
    ${media.mobileDevice`
    margin-top: ${({ isProductTemplateExclusionItems }) =>
        isProductTemplateExclusionItems ? '14px' : 'unset'};
    max-height: ${({ isProductTemplateExclusionItems }) =>
        isProductTemplateExclusionItems ? '142px' : '70px'};
`};
`;
